import { theme } from '../theme.js';
import { useThemePref, type ThemePref } from '../lib/themePref.js';

const OPTIONS: { value: ThemePref; label: string }[] = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
  { value: 'system', label: 'System' },
];

/** Profile card: light / dark / follow the device. */
export function AppearanceCard() {
  const [pref, setPref] = useThemePref();

  return (
    <div style={{
      margin: '12px 16px', padding: '12px 14px', borderRadius: 12,
      background: theme.surface, border: `1px solid ${theme.border}`,
      fontFamily: theme.font, display: 'flex', alignItems: 'center', gap: 12,
    }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: theme.text }}>Appearance</div>
        <div style={{ fontSize: 12, color: theme.textMuted, lineHeight: 1.4 }}>
          {pref === 'system' ? 'Matches this device' : 'On this device'}
        </div>
      </div>
      <div role="radiogroup" aria-label="Appearance" style={{
        display: 'flex', padding: 3, gap: 2, borderRadius: 10, background: theme.surface2,
        border: `1px solid ${theme.border}`, flexShrink: 0,
      }}>
        {OPTIONS.map((o) => {
          const on = o.value === pref;
          return (
            <button
              key={o.value}
              role="radio"
              aria-checked={on}
              onClick={() => setPref(o.value)}
              style={{
                padding: '6px 10px', borderRadius: 7, border: 'none', cursor: 'pointer',
                fontFamily: theme.font, fontSize: 12, fontWeight: 600,
                background: on ? theme.accent : 'transparent',
                color: on ? theme.accentInk : theme.textDim,
              }}
            >
              {o.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
